<template>
	<v-img :src="fundo" aspect-ratio="1.934">
		<v-container>
			<v-layout justify-center>
            	<v-flex>
					<v-card>
						<v-layout justify-center>
							<v-flex lg12 style="padding: 10px;">
								<h1> Desculpe, Você ainda não tem acesso a esta aplicação! </h1> 
							</v-flex>
						</v-layout>
						<v-card-text class="text-xs-center"> 
							<v-layout justify-center>
            					<v-flex lg12>
									<h3>Entre em contato com a Granter e obtenha acesso a mais esta ferramenta!</h3>
            					</v-flex>
							</v-layout>
							<v-layout justify-center>
								<v-flex xl11 lg10 sm10>
									<p> Saiba mais em: <a href="http://www.granter.com.br/meulote"> Meu Lote</a></p>
								</v-flex>
								<v-flex xl2 lg3 sm4 style="margin-top: -15px;">
									<v-btn id="return" rounded @click="$keycloak.logout()" style="background-color:#e8e8e8;">
										<span class="marginSpan"> Entrar com outra conta </span>
									</v-btn>
								</v-flex>
							</v-layout>
						</v-card-text>
					</v-card>
				</v-flex>
			</v-layout>
		</v-container>
	</v-img>
</template>

<script>

import granterFundo  from "@/assets/fundo_granter.jpg"

export default {
	name: 'App',
	computed: {
		fundo () {
			return granterFundo
		},
	},
	components:{
	},
	data () {
		return {
			
		}
	},
	methods: {
		
	},
	created () {
	}
}
</script>
